module.exports = __webpack_public_path__ + "static/img/it3.cf4a333.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/it3.png
// module id = mbh3
// module chunks = 0